document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll("[id^='slider-']");

  sliders.forEach(slider => {
    const container = slider;
    const sectionId = slider.id.split("slider-")[1];

    const prevBtn = document.querySelector(`.section-${sectionId} .slider-prev`);
    const nextBtn = document.querySelector(`.section-${sectionId} .slider-next`);

    const slideWidth = slider.querySelector(".feature-cards-slide").offsetWidth + 24;

    prevBtn.addEventListener("click", () => {
      container.scrollLeft -= slideWidth;
    });

    nextBtn.addEventListener("click", () => {
      container.scrollLeft += slideWidth;
    });
  });
});
